"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.APP_BASE_TABLE_TARGET_IN_APP = exports.APP_BASE_TABLE_CHOICE_UNKNOWN = exports.APP_BASE_TABLE_STILL_USED = exports.APP_BASE_TABLE_CHOICE_MISSING = exports.AppBaseTableDispositionSchema = void 0;
exports.planAppTableChoices = planAppTableChoices;
exports.appTableChoiceIssues = appTableChoiceIssues;
const zod_1 = require("zod");
const app_base_config_1 = require("./app-base-config");
/**
 * What deleting an App Module or App Container for good does with one table
 * it owns alone: the table is deleted with its rows, or moved onto a page
 * outside every App folder and kept there without the binding.
 */
exports.AppBaseTableDispositionSchema = zod_1.z.discriminatedUnion('action', [
    zod_1.z
        .object({ sourceKey: zod_1.z.string().min(1), action: zod_1.z.literal('delete') })
        .strict(),
    zod_1.z
        .object({
        sourceKey: zod_1.z.string().min(1),
        action: zod_1.z.literal('move'),
        targetDocId: zod_1.z.string().min(1),
    })
        .strict(),
]);
/** A table the delete removes has no choice in the list. */
exports.APP_BASE_TABLE_CHOICE_MISSING = 'APP_BASE_TABLE_CHOICE_MISSING';
/** The list chooses for a table the delete keeps: other Apps use it or it was attached. */
exports.APP_BASE_TABLE_STILL_USED = 'APP_BASE_TABLE_STILL_USED';
/** The list names a table the App does not have, or one table twice. */
exports.APP_BASE_TABLE_CHOICE_UNKNOWN = 'APP_BASE_TABLE_CHOICE_UNKNOWN';
/** A kept table would move onto a page inside an App folder, which the delete removes. */
exports.APP_BASE_TABLE_TARGET_IN_APP = 'APP_BASE_TABLE_TARGET_IN_APP';
function planAppTableChoices(appBaseConfig, target) {
    if (target.kind === 'app') {
        const plan = (0, app_base_config_1.planTrashedAppRemoval)(appBaseConfig, target.appId);
        return {
            choices: plan.removedDataSources,
            retained: plan.retainedDataSources,
        };
    }
    const choices = [];
    const retained = [];
    for (const [sourceKey, binding] of Object.entries(appBaseConfig.databaseBindings)) {
        if (binding.status !== 'active')
            continue;
        if (binding.ownership === 'app-base-owned')
            choices.push({
                sourceKey,
                label: binding.label,
                reason: 'exclusive-owned',
            });
        else
            retained.push({
                sourceKey,
                label: binding.label,
                reason: 'attached-existing',
            });
    }
    return { choices, retained };
}
/** Exactly one choice per table of `choices`, none for any other table. */
function appTableChoiceIssues(plan, tables) {
    const owned = new Set(plan.choices.map(source => source.sourceKey));
    const retained = new Set(plan.retained.map(source => source.sourceKey));
    const chosen = new Set();
    const issues = [];
    for (const { sourceKey } of tables) {
        if (retained.has(sourceKey))
            issues.push({ code: exports.APP_BASE_TABLE_STILL_USED, sourceKey });
        else if (!owned.has(sourceKey) || chosen.has(sourceKey))
            issues.push({ code: exports.APP_BASE_TABLE_CHOICE_UNKNOWN, sourceKey });
        chosen.add(sourceKey);
    }
    for (const sourceKey of owned)
        if (!chosen.has(sourceKey))
            issues.push({ code: exports.APP_BASE_TABLE_CHOICE_MISSING, sourceKey });
    return issues;
}
